// extracted by mini-css-extract-plugin
export default {"wrapper":"AddNetworking_wrapper__HJiyd","col":"AddNetworking_col__5wwY-"};